import { css, cx } from 'emotion';
import { pink, lightGrey, textBlock } from 'inside-out/global-styles';
import CheckedIcon from 'inside-out/images/checked-icon.svg';

export const labelStyle = css({
	display: 'block',
	marginBottom: '16px',
	'& svg': {
		marginLeft: '10px',
	},
	'& > span': cx(
		textBlock,
		css({
			marginLeft: '10px',
			lineHeight: '1',
			verticalAlign: 'middle',
		})
	),
});

export const checkboxStyle = css({
	textIndent: '-99999px',
	fontSize: 0,
	width: '16px',
	height: '16px',
	display: 'inline-block',
	position: 'relative',
	cursor: 'pointer',
	verticalAlign: 'middle',
	'&:before': {
		content: "' '",
		display: 'block',
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		borderRadius: '3px',
		background: '#fff',
		border: `1px solid ${lightGrey}`,
	},
	'&:checked:after': {
		content: "' '",
		display: 'block',
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: pink,
		backgroundImage: `url(${CheckedIcon})`,
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: '10px',
		borderRadius: '3px',
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/audienceFilter/styles.js